define.alias("shared/components/shared/ui/icon-tooltip", "calendar/components/shared/ui/icon-tooltip");